import { Spacing, Icon } from '@bluevision/components';
import React from 'react';
import { useTranslation } from 'react-i18next';

import styles from './styles.less';

const HelpCenter: React.FC = () => {
  const { t } = useTranslation();
  return (
    <a
      href='https://bluefocus.feishu.cn/wiki/GQXTwZv6DifRuMkQg7DcdAICnDc'
      target='_blank'
      className={styles['help-center']}
      rel='noreferrer'
    >
      <Spacing spacing={6}>
        <Icon name='question-mark' />
        {t('help_center')}
      </Spacing>
    </a>
  );
};

export default HelpCenter;
